import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  FormControl,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import React from "react";
import RefreshGrid from "../Refresh/RefreshGrid";
import {
  GridAddIcon,
  GridMoreVertIcon,
  GridSearchIcon,
} from "@mui/x-data-grid";
import { useAuth } from "../../context/AuthContext";

const GridCustomHeader = ({
  isLoading,
  setIsLoading,
  searchText,
  handleSearch,
  setOpenModal,
  headerName = "Membership",
  open,
  handleClick,
  handleClose,
  anchorEl,
  buttonText = "Add New Member",
  moreOptions = false,
  showClosedBusiness = false,
  setOpenReportModal = () => {},
  role = "ADMIN",
  status = "active",
  onStatusChange = () => {},
  showStatusSwitch = false,
  hideAddButton = false,
  children,
}) => {
  const { user } = useAuth();
  const isMember = role === "MEMBER";

  const handleActiveMember = () => {
    window.open("/active-member-roster");
    handleClose();
  };

  const handleMemberActivity = () => {
    setOpenReportModal({
      open: true,
      showAllTime: false,
      generalClosedBusiness: false,
    });
    handleClose();
  };

  const handleCloseBusinessReport = () => {
    setOpenReportModal({
      open: true,
      showAllTime: true,
      generalClosedBusiness: true,
    });
    handleClose();
  };

  const handleIndividualAllReport = () => {
    window.open("/all-active-member-report");
    handleClose();
  };

  const handleIndividualReport = () => {
    const memberId = user?.id;
    if (memberId) {
      localStorage.setItem("memberId", memberId);
    } else {
      localStorage.removeItem("memberId");
    }
    window.open("/member-individual-report");
    handleClose();
  };

  const handleExtendedReport = () => {
    const memberId = user?.id;
    if (memberId) {
      localStorage.setItem("memberId", memberId);
    } else {
      localStorage.removeItem("memberId");
    }
    window.open("/member-extended-report");
    handleClose();
  };

  const handleOverallActivityReport = () => {
    setOpenReportModal({
      open: true,
      showAllTime: true,
      overallActivity: true,
    });
    handleClose();
  };

  const handleStatusToggle = (e) => {
    const checked = e.target.checked;
    onStatusChange(checked ? "active" : "inactive");
  };

  const statusLabel = status === "active" ? "Active" : "Inactive";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "16px",
        backgroundColor: "#fff",
        padding: "12px 16px",
        borderRadius: "8px",
        border: "1px solid #E2E8F0",
      }}
      className="grid-header-container"
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <h5 className="grid-header">{headerName}</h5>
        <RefreshGrid
          isFetching={isLoading}
          refetch={() => setIsLoading(true)}
        />
      </Box>

      <Box
        sx={{ display: "flex", alignItems: "center", gap: "16px" }}
        className="grid-search-container"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #AEBBCB",
            borderRadius: "29px",
            padding: "4px 16px",
            maxWidth: "360px",
          }}
        >
          <GridSearchIcon sx={{ color: "#64748B" }} />
          <TextField
            placeholder="Search"
            variant="standard"
            InputProps={{
              disableUnderline: true,
              sx: { fontSize: "14px", marginLeft: "8px", color: "#475569" },
            }}
            sx={{ width: "318px" }}
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Box>

        {showStatusSwitch && (
          <FormControl component="fieldset" variant="standard">
            <FormGroup>
              <FormControlLabel
                className="gap-4"
                control={
                  <Switch
                    checked={status === "active"}
                    onChange={handleStatusToggle}
                    name="status"
                    className="switchStyles"
                  />
                }
                label={statusLabel}
              />
            </FormGroup>
          </FormControl>
        )}
      </Box>

      {showStatusSwitch ? (
        <FormControl
          component="fieldset"
          variant="standard"
          sx={{
            marginLeft: "auto",
            marginRight: "0",
          }}
          className="mobile-switcher"
        >
          <FormGroup>
            <FormControlLabel
              className="gap-4"
              control={
                <Switch
                  checked={status === "active"}
                  onChange={handleStatusToggle}
                  name="status"
                  className="switchStyles"
                />
              }
              label={statusLabel}
            />
          </FormGroup>
        </FormControl>
      ) : (
        <div></div>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #AEBBCB",
          borderRadius: "29px",
          padding: "4px 16px",
          maxWidth: "360px",
        }}
        className="mobile-grid-search-container"
      >
        <GridSearchIcon sx={{ color: "#64748B" }} />
        <TextField
          placeholder="Search"
          variant="standard"
          InputProps={{
            disableUnderline: true,
            sx: { fontSize: "14px", marginLeft: "8px", color: "#475569" },
          }}
          sx={{ maxWidth: "318px" }}
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </Box>

      <Box
        sx={{ display: "flex", alignItems: "center", gap: "16px" }}
        className="add-new-button-container"
      >
        {children}
        {!isMember && !hideAddButton && (
          <Button
            variant="contained"
            startIcon={<GridAddIcon />}
            className="add-new-button"
            onClick={() => {
              setOpenModal(true);
            }}
          >
            <span className="add-new-text">{buttonText}</span>
          </Button>
        )}

        {moreOptions && (
          <>
            <IconButton
              sx={{ border: "1px solid #AEBBCB" }}
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <GridMoreVertIcon />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {!showClosedBusiness && !isMember && (
                <>
                  <MenuItem onClick={handleMemberActivity}>
                    Member Activity Report
                  </MenuItem>
                  <MenuItem onClick={handleActiveMember}>
                    Active Member Roster
                  </MenuItem>
                </>
              )}

              {!isMember && (
                <>
                  <MenuItem onClick={handleCloseBusinessReport}>
                    Closed Business Report
                  </MenuItem>
                  <MenuItem onClick={handleIndividualAllReport}>
                    Active Members Individual Report
                  </MenuItem>
                </>
              )}
              {isMember && (
                <>
                  <MenuItem onClick={handleMemberActivity}>
                    Member Activity Report
                  </MenuItem>
                  <MenuItem onClick={handleIndividualReport}>
                    My Member Individual Report
                  </MenuItem>
                  <MenuItem onClick={handleExtendedReport}>
                    My Member Individual Extended Report
                  </MenuItem>
                </>
              )}
              <MenuItem onClick={handleOverallActivityReport}>
                Overall Activity Report
              </MenuItem>
            </Menu>
          </>
        )}
      </Box>
    </Box>
  );
};

export default GridCustomHeader;
